import { rem } from 'polished';
import { Link as _Link } from 'gatsby';

import { styled } from '~/stitches.config';

export const Link = styled(_Link, {
  height: rem(18),
});
